import { hexToRGB } from '@repo-level/core-front';
import styled from 'styled-components';

interface ScMobileHeaderProps {
  isTop: boolean;
  isAuth: boolean;
  withEmailConfirmationPopup: boolean;
  emailConfirmationPopupHeight: number;
}

export const ScMobileHeader = styled.div<ScMobileHeaderProps>`
  position: sticky;
  inset: ${({ withEmailConfirmationPopup, emailConfirmationPopupHeight }) =>
    `${
      withEmailConfirmationPopup ? emailConfirmationPopupHeight : -1
    }px 0 auto`};
  z-index: 111;
  height: 56px;
  padding: 8px 16px;
  display: flex;
  justify-content: ${({ isAuth }) => (isAuth ? 'space-between' : 'center')};
  align-items: center;
  background: ${({ theme, isTop }) => (isTop ? 'inherit' : theme.grayColor5)};
  transition: 0.3s;
  box-shadow: ${({ theme, isTop }) =>
    isTop ? 'inherit' : `0px 8px 30px 0px ${hexToRGB(theme.blackColor, 0.6)}`};

  @media print {
    display: none;
  }

  & > .wallet {
    & > div {
      width: auto;
      padding: 0;

      .select-wallet {
        width: auto;

        .current-wallet > .wallet-value {
          padding-right: 16px;
          font-size: 14px;
        }
      }
    }
  }
`;
